/**
 * GDPR-Compliant Cookie Management Utility
 * Handles cookie consent storage and retrieval
 */

const COOKIE_CONSENT_KEY = 'cookie_consent'
const COOKIE_EXPIRY_DAYS = 365 // Consent valid for 1 year

/**
 * Get cookie consent status
 * @returns {Object|null} Consent object or null if not set
 */
export function getCookieConsent() {
  try {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (consent) {
      return JSON.parse(consent)
    }
  } catch (e) {
    console.error('Error reading cookie consent:', e)
  }
  return null
}

/**
 * Set cookie consent
 * @param {Object} consent - Consent object with {analytics: boolean, timestamp: number}
 */
export function setCookieConsent(consent) {
  try {
    const consentData = {
      ...consent,
      timestamp: Date.now(),
      expires: Date.now() + (COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000)
    }
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consentData))
  } catch (e) {
    console.error('Error saving cookie consent:', e)
  }
}

/**
 * Check if user has given consent for analytics
 * @returns {boolean}
 */
export function hasAnalyticsConsent() {
  const consent = getCookieConsent()
  if (!consent) return false
  
  // Check if consent has expired
  if (consent.expires && Date.now() > consent.expires) {
    return false
  }
  
  return consent.analytics === true
}

/**
 * Check if user has made a consent decision
 * @returns {boolean}
 */
export function hasConsentDecision() {
  return getCookieConsent() !== null
}

/**
 * Revoke all cookie consent
 */
export function revokeCookieConsent() {
  try {
    localStorage.removeItem(COOKIE_CONSENT_KEY)
  } catch (e) {
    console.error('Error revoking cookie consent:', e)
  }
}

